import { render, staticRenderFns } from "./AAsignarCobrador.vue?vue&type=template&id=6a188140"
import script from "./AAsignarCobrador.vue?vue&type=script&lang=js"
export * from "./AAsignarCobrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports